export const colors = [
  '#2BB5CF',
  '#1D495C',
  '#73DBED',
  '#ACEBF5',
  '#A4BFCE',
  '#59879E',
  '#B0B0B0',
  '#5D5D5D',
  '#262626',
  '#CAFDEF',
  '#59EFD0',
  '#0E6158',
  '#0EBEA2',
  '#0B7A6B',
];
